<template>
  <div class="my-notify-dialog">
    <el-dialog style="margin-top: 40px" :visible.sync="isShow" :title="title" width="50%" center @close="dialogClose">
      <div class="dialog-sign">
        <el-image v-if="success" :src="require('@/assets/success.png')"
                  style="width: 200px; height: 200px"></el-image>
        <el-image v-else :src="require('@/assets/false.png')" style="width: 200px; height: 200px"></el-image>
        <div style="margin-top: 10px; font-size: 18px">{{ msg }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "MyNotifyDialog",
  props: {
    show: {type: Boolean,},
    success: {type: Boolean,},
    title: {type: String,},
    msg: {type: String,}
  },
  data() {
    return {
      isShow: false,
    }
  },
  watch: {
    show: {
      handler: function (val) {
        this.isShow = val
      },
      immediate: true
    },
  },
  methods: {
    dialogClose() {
      this.$emit('dialogClose', false)
    }
  }
}
</script>

<style scoped lang="less">
.dialog-sign {
  display: flex;
  height: 45vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

</style>